import { enqueueSnackbar } from "notistack";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getRequestAuthenticationRequest,
  putAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import {
  FETCH_PROFILE_DETAILS_FAILURE,
  FETCH_PROFILE_DETAILS_REQUEST,
  FETCH_PROFILE_DETAILS_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
} from "../constants";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const getProfileDetails =
  (id, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PROFILE_DETAILS_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        `${apiConfig.getProfileDetails}${id}`,
        null,
      );
      if (response) {
        dispatch({
          type: FETCH_PROFILE_DETAILS_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: FETCH_PROFILE_DETAILS_FAILURE,
          payload: {},
        });
        callback({});
        enqueueSnackbar("Error fetching company details", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching company details", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: FETCH_PROFILE_DETAILS_FAILURE,
        payload: {},
      });
    }
  };

export const updateProfile =
  (id, values, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PROFILE_REQUEST,
      });
      const response = await putAuthenticationRequest(
        `${apiConfig.updateProfile}${id}`,
        values,
      );
      if (response) {
        dispatch({
          type: UPDATE_PROFILE_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: UPDATE_PROFILE_FAILURE,
        });
        callback({});
        enqueueSnackbar("Error updating profile details", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error updating profile details", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: UPDATE_PROFILE_FAILURE,
      });
    }
  };
